import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { GetRoomCategories } from "../../../../api/ipd/roomCategoryAPI";
import { GetRoomById, UpdateRoom } from "../../../../api/ipd/roomAPI";
import { GetNursingStations } from "../../../../api/ipd/nursingStationAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  roomNo: yup.string().required("roomNo is required"),
  roomDescription: yup.string().required("Room Description is required"),
  roomCategoryId: yup.string().required("Room Category is required"),
  nursingStationId: yup.string().required("Nursing Station is required"),
  roomCharges: yup.string().required("Room Charges is required"),
  type: yup.string().required("Type is required"),
  active: yup.string().required("Active is required")
});

const EditRoom = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [roomCategories, setRoomCategories] = useState([]);
  const [nursingStations, setNursingStations] = useState([]);

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchRoomCategories = async () => {
    try {
      const response = await GetRoomCategories(); // Make sure login function returns token
      if (response.success) {
        setRoomCategories(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  const fetchNursingStations = async () => {
    try {
      const response = await GetNursingStations(); // Make sure login function returns token
      if (response.success) {
        setNursingStations(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await GetRoomById(id); // Make sure login function returns token

      if (response.success) {
        Object.entries(response.data).forEach(([key, value]) => {
          setValue(key, value);
        });

        setValue("roomCategoryId", response.data.roomCategoryId);
        setValue("nursingStationId", response.data.nursingStationId);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      if (id) {
        fetchNursingStations().then(() => {
          fetchRoomCategories().then(() => {
            fetchData();
          });
        });
      }
    },
    [id, setValue]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateRoom(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Room" title="Edit Room" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Edit Room</h5>
                  <Link to={`/ipd/master/room/list`}>
                    <button className="btn btn-primary" id="list">
                      List Room
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Room
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Room No *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Room No"
                          {...register("roomNo")}
                        />
                        {errors.roomNo &&
                          <p className="text-danger">
                            {errors.roomNo.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Room Description *</label>
                        <textarea
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Room Description"
                          {...register("roomDescription")}
                        />
                        {errors.roomDescription &&
                          <p className="text-danger">
                            {errors.roomDescription.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Room Category *</label>
                        <select
                          className="form-control"
                          id="name"
                          type="text"
                          {...register("roomCategoryId")}
                        >
                          <option value="">Select Room Category</option>
                          {roomCategories.map(roomC =>
                            <option value={roomC._id}>
                              {roomC.name}
                            </option>
                          )}
                        </select>
                        {errors.roomCategoryId &&
                          <p className="text-danger">
                            {errors.roomCategoryId.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Nursing Station *</label>
                        <select
                          className="form-control"
                          id="name"
                          type="text"
                          {...register("nursingStationId")}
                        >
                          <option value="">Select Nursing Station</option>
                          {nursingStations.map(nursingStation =>
                            <option value={nursingStation._id}>
                              {nursingStation.name}
                            </option>
                          )}
                        </select>
                        {errors.nursingStationId &&
                          <p className="text-danger">
                            {errors.nursingStationId.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Room Charges *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="number"
                          placeholder="Room Charges"
                          {...register("roomCharges")}
                        />
                        {errors.roomCharges &&
                          <p className="text-danger">
                            {errors.roomCharges.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Type</label>
                        <select
                          className="form-control"
                          id="name"
                          type="text"
                          {...register("type")}
                        >
                          <option value="Room">Room</option>
                          <option value="OT">OT</option>
                        </select>
                        {errors.type &&
                          <p className="text-danger">
                            {errors.type.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Select Active</label>
                        <select
                          className="form-control"
                          id="name"
                          type="text"
                          {...register("active")}
                        >
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {errors.active &&
                          <p className="text-danger">
                            {errors.active.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditRoom;
